"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attach = attach;
exports.detach = detach;
exports.getConfig = getConfig;
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } /*
 Copyright (c) 2018 Wells Fargo. 333 Market St., San Francisco, CA 94105 All rights reserved.
 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.
 */ /**
 * Code reuse from retry-axios library.
 *
 * The original library is not compatible with IE11 so this code has been modified here.
 *
 * @module retry-axios
 *
 * @author Vinothkumar V. Kalyanasundaram
 * @copyright 2018 Wells Fargo, All rights reserved.
 */
/**
 * Attach the interceptor to the Axios instance.
 *
 * @param {*} instance The optional Axios instance on which to attach the
 * interceptor.
 * @return {*} The id of the interceptor attached to the axios instance.
 */
function attach(instance) {
  // eslint-disable-next-line no-param-reassign
  instance = instance || _axios["default"];
  if (instance.interceptors) {
    return instance.interceptors.response.use(onFulfilled, onError);
  } else {
    return {};
  }
}

/**
 * Eject the Axios interceptor that is providing retry capabilities.
 *
 * @param {*} interceptorId The interceptorId provided in the config.
 * @param {*} instance The axios instance using this interceptor.
 */
function detach(interceptorId, instance) {
  // eslint-disable-next-line no-param-reassign
  instance = instance || _axios["default"];
  instance.interceptors.response.eject(interceptorId);
}

/**
 * Passthrough function that returns the arg passed in
 *
 * @param {*} res The arg to be returned
 * @return {*} The arg passed in
 */
function onFulfilled(res) {
  return res;
}

/**
 * Checks is the status code is in the range specified in configuration
 *
 * @param {*} statusCodesToRetry set of status code ranges to match
 * @param {*} response response object containing a status code
 * @return {boolean} true if the status code is in range, false otherwise
 */
function isInRange(statusCodesToRetry, response) {
  var isInRange = false;
  // eslint-disable-next-line no-restricted-syntax
  var _iterator = _createForOfIteratorHelper(statusCodesToRetry),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        min = _step$value[0],
        max = _step$value[1];
      var status = response.status;
      if (status >= min && status <= max) {
        isInRange = true;
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return isInRange;
}

/**
 * Error handler that does retry
 *
 * @param {*} err The network error
 * @return {boolean} true if a retry was executed, false otherwise
 */
function onError(err) {
  err.config = err.config || {};
  var config = err.config.raxConfig || {};
  config.currentRetryAttempt = config.currentRetryAttempt || 0;
  config.retry = config.retry === undefined || config.retry === null ? 3 : config.retry;
  config.retryDelay = config.retryDelay || 100;
  config.instance = config.instance || _axios["default"];
  config.httpMethodsToRetry = config.httpMethodsToRetry || ['GET', 'HEAD', 'PUT', 'OPTIONS', 'DELETE'];
  config.noResponseRetries = config.noResponseRetries === undefined || config.noResponseRetries === null ? 2 : config.noResponseRetries;
  // If this wasn't in the list of status codes where we want
  // to automatically retry, return.
  var retryRanges = [
  // https://en.wikipedia.org/wiki/List_of_HTTP_status_codes
  // 1xx - Retry (Informational, request still processing)
  // 2xx - Do not retry (Success)
  // 3xx - Do not retry (Redirect)
  // 4xx - Do not retry (Client errors)
  // 429 - Retry ("Too Many Requests")
  // 5xx - Retry (Server errors)
  [100, 199], [500, 599]];
  config.statusCodesToRetry = config.statusCodesToRetry || retryRanges;
  // Put the config back into the err
  // eslint-disable-next-line no-param-reassign
  err.config.raxConfig = config;
  // Determine if we should retry the request
  var shouldRetryFn = config.shouldRetry || shouldRetryRequest;
  if (!shouldRetryFn(err)) {
    return Promise.reject(err);
  }
  // Calculate time to wait with exponential backoff.
  // Formula: (2^c - 1 / 2) * 1000
  // eslint-disable-next-line no-restricted-properties
  var delay = (Math.pow(2, config.currentRetryAttempt) - 1) / 2 * 1000;
  // We're going to retry!  Incremenent the counter.
  // eslint-disable-next-line no-param-reassign
  err.config.raxConfig.currentRetryAttempt += 1;
  // Create a promise that invokes the retry after the backOffDelay
  var backoff = new Promise(function (resolve) {
    setTimeout(resolve, delay);
  });
  // Notify the user if they added an `onRetryAttempt` handler
  if (config.onRetryAttempt) {
    config.onRetryAttempt(err);
  }
  // Return the promise in which recalls axios to retry the request
  return backoff.then(function () {
    return config.instance.request(err.config);
  });
}

/**
 * Determine based on config if we should retry the request.
 *
 * @param {*} err The AxiosError passed to the interceptor.
 * @return {boolean} true to retry, false otherwise
 */
function shouldRetryRequest(err) {
  var config = err.config.raxConfig;

  // If there's no config, or retries are disabled, return.
  if (!config || config.retry === 0) {
    return false;
  }
  // Check if this error has no response (ETIMEDOUT, ENOTFOUND, etc)
  if (!err.response && (config.currentRetryAttempt || 0) >= config.noResponseRetries) {
    return false;
  }
  // Only retry with configured HttpMethods.
  if (!err.config.method || config.httpMethodsToRetry.indexOf(err.config.method.toUpperCase()) < 0) {
    return false;
  }
  // If this wasn't in the list of status codes where we want
  // to automatically retry, return.
  if (err.response && err.response.status) {
    if (!isInRange(config.statusCodesToRetry, err.response)) {
      return false;
    }
  }
  // If we are out of retry attempts, return
  config.currentRetryAttempt = config.currentRetryAttempt || 0;
  if (config.currentRetryAttempt >= config.retry) {
    return false;
  }
  return true;
}

/**
 * Acquire the raxConfig object from an AxiosError if available.
 *
 * @param {*} err The Axios error with a config object.
 * @return {*} raxConfig if it exists, null otherwise
 */
function getConfig(err) {
  if (err && err.config) {
    return err.config.raxConfig;
  }
  return null;
}
//# sourceMappingURL=retry-axios.js.map